import React from "react";
import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import MarketingHeader from "../components/argus/MarketingHeader";
import Footer from "../components/argus/Footer";
import { Button } from "../components/ui/button";
import { SOLUTIONS, PRODUCTS } from "../lib/marketingContent";

export default function Solution() {
  const { slug } = useParams();
  const s = SOLUTIONS[slug];
  if (!s) return <Navigate to="/" replace />;

  const linked = (s.related || []).map((k) => PRODUCTS[k]).filter(Boolean);

  return (
    <div className="bg-paper text-ink min-h-screen flex flex-col">
      <MarketingHeader />
      <section className="mx-auto max-w-6xl w-full px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <p className="text-xs uppercase tracking-wider text-gold mb-3 font-semibold">Solution</p>
        <h1 className="font-display text-5xl sm:text-6xl tracking-tight max-w-3xl" data-testid="solution-title">{s.name}.</h1>
        <p className="mt-2 text-2xl font-display text-ink/70 max-w-2xl" data-testid="solution-tagline">{s.tagline}</p>
        <p className="mt-6 text-lg text-ink/70 max-w-2xl">{s.summary}</p>

        <div className="mt-10 grid md:grid-cols-2 gap-8">
          <div className="rounded-xl border border-line bg-panel p-6">
            <h2 className="font-display text-2xl mb-4">What ArgusSecure does here.</h2>
            <ul className="space-y-3">
              {s.bullets.map((b, i) => (
                <li key={i} className="flex items-start gap-3 text-ink/80" data-testid={`solution-bullet-${i}`}>
                  <CheckCircle2 size={18} className="text-safe shrink-0 mt-0.5" />
                  <span>{b}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="rounded-xl border border-line bg-panel p-6">
            <h2 className="font-display text-2xl mb-4">Products in this play.</h2>
            <ul className="space-y-2 text-sm">
              {linked.map((p) => (
                <li key={p.slug}>
                  <Link to={`/products/${p.slug}`} className="block py-2 hover:text-gold" data-testid={`solution-product-${p.slug}`}>
                    <span className="font-medium">{p.name}</span>
                    <span className="block text-xs text-ink/40">{p.tagline}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12">
          <Link to="/signup">
            <Button className="bg-gold text-paper hover:bg-gold2 h-12 px-6 font-semibold" data-testid="solution-cta">
              Start My Free Scan <ArrowRight size={16} className="ml-2" />
            </Button>
          </Link>
        </div>
      </section>
      <Footer />
    </div>
  );
}
